module.exports = __webpack_public_path__ + "static/img/ari.9eeecd6.jpg";